<template>
	<div class="k-component -contact">
		<b-container>
			<b-row align-h="center">
				<b-col col lg="8" class="text-center">
					<h1 v-if="contactData.title">{{ contactData.title }}</h1>
					<h2 v-if="contactData.subtitle">{{ contactData.subtitle }}</h2>
					<p v-if="contactData.description" class="lead mb-0">{{ contactData.description }}</p>
					<hr class="my-5" />
				</b-col>
			</b-row>
		</b-container>
		<b-container>
			<b-row>
				<ContactItem v-for="itemData in contactData.items" :key="itemData.id" :item-data="itemData" />
			</b-row>
		</b-container>
	</div>
</template>

<script>
import ContactItem from '@/components/ContactItem.vue'

export default {
	name: 'Contact',

	components: {
		ContactItem
	},

	props: {
		contactData: {
			type: Object,
			required: true
		}
	}
}
</script>

<style lang="scss">
@import '@/assets/scss/_component-contact.scss';
</style>
